
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 23a2.26 2.26 0 002.25-2.256h-4.5A2.252 2.252 0 0012 23zm6.75-6.769V10.59c0-3.464-1.845-6.363-5.063-7.131v-.767a1.687 1.687 0 10-3.375 0v.767C7.084 4.227 5.25 7.115 5.25 10.59v5.641L3 18.487v1.128h18v-1.128l-2.25-2.256z","fill-rule":"nonzero"}})])
          )
        }
      }
    